module.exports = __webpack_public_path__ + "static/media/img-3.555a0e9b.jpg";